enum Tray {
  Private = 'private',
  Public = 'public',
}

export default Tray;
